import React from 'react';
import { observer } from 'mobx-react-lite';
import { Form, Input, Button } from 'antd';
import client from '@/store/client';
import { request } from '@src/common';
import { HelpOther } from '@/common/helper';
import agentPageStore from '@src/pages/agent-home/store';
import InviteFormModal from '../invite-form';
import InviteCodeModal from './index';

import './style.scss';
import globalStore from '@/store/global';

const InviteCode = observer(({ agentId, callback } = {}) => {
  const [form] = Form.useForm();

  /** 跳转到邀请表单 */
  const gotoInviteForm = () => {
    InviteCodeModal.close();
    InviteFormModal.show();
  };

  /** 提交邀请码 */
  const onSubmit = () => {
    form.validateFields()
    .then(() => {
      const data = form.getFieldsValue();

      request({
        url: '/invitation/verify',
        method: 'post',
        data: {
          code: data.code,
        },
      }).then(res => {
        HelpOther.toast('助力码验证成功', 'success');
        InviteCodeModal.close();
        if(callback){
          callback();
        }
        else {
          if(client.supportMcpAgent){
            agentPageStore.gotoAgentChat(agentId || agentPageStore.superAgentId);
          }else{
            client.openPage('/download');
          }
        }
      }).catch(e => {
        HelpOther.toast(e.msg, 'error');
      });
    });
  };

  return (
    <div className="invite-code w-552px p-24px !pb-19px bg-[#fff] rounded-24px box-border" style={{
      background: 'url(https://p4.ssl.qhimg.com/t110b9a930194c36398010fec98.png) no-repeat center top',
      backgroundSize: '552px auto',
    }}>
      <h3 className="text-24px font-bold-500 mb-0 leading-34px text-[#000]">
        为好友助力，获得限免智能体使用次数
      </h3>
      <div className="pt-4px text-14px leading-20px text-black/50">
        输入助力码，双方均可获得 {globalStore.cloudConfig?.assistantMcpServerConfig?.invited_count} 次限免智能体的试用次数。
      </div>
      <div className="pt-4px pb-24px text-14px leading-20px text-black/50">
        请确保客户端已升级至最新版本。
        <span
          className="text-[#006AFF] cursor-pointer pl-4px hover:text-[#005EE3]"
          onClick={() => client.openPage('/download')}
        >
          下载新版本
        </span>
      </div>

      <Form layout="vertical" form={form} autoComplete='off' requiredMark={false}>
        <Form.Item
          className="!mb-10px"
          name="code"
          label="输入助力码"
          rules={[{ required: true, message: '请输入助力码' }]}
        >
          <Input placeholder="请输入您的助力码" />
        </Form.Item>

        {/* <div className="text-12px leading-17px text-black/50">
          若您尚未拥有邀请码，可点击此处
          <span className="text-[#006AFF] pl-4px cursor-pointer hover:text-[#005EE3]" onClick={gotoInviteForm}>
            申请邀请码
          </span>
        </div> */}

        {/* footer */}
        <Form.Item className="flex justify-end !mt-18px !mb-0">
          <Button
            type="primary"
            htmlType="button"
            className="mr-16px cancel"
            onClick={() => {
              InviteCodeModal.close();
            }}
          >
            取消
          </Button>
          <Button type="primary" htmlType="button" onClick={onSubmit}>
            确认
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
});

export default InviteCode;
